import { render, staticRenderFns } from "./commission-invoice.vue?vue&type=template&id=45b5c736&"
import script from "./commission-invoice.vue?vue&type=script&lang=ts&"
export * from "./commission-invoice.vue?vue&type=script&lang=ts&"
import style0 from "./commission-invoice.vue?vue&type=style&index=0&id=45b5c736&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports